import {
  CHANGE_BOTACTIVATION,
  CHANGE_PROPERTYID,
  CHANGE_PROPERTYNAME,
  CHANGE_DOMAIN,
  CHANGE_AVATARCLICK,
  CURRENT_GROUPID,
  CURRENT_GROUPNAME,
  CHANGE_LEVEL,
  IS_GROUP_BUTTON,
  CHANGE_INTEGRATION_CHANNEL,
  CHAT_STARTED,
  CHANGE_BACK_TO_LIST,
  CHANGE_CURRENCY,
  CHANGE_MODE,
  CHANGE_BACK_TO_QUESTION,
} from "../actions";

export const changeBotActivation = (val) => {
  localStorage.setItem("messengerBotActivation", val);
  return {
    type: CHANGE_BOTACTIVATION,
    payload: val,
  };
};

export const changePropertyId = (id) => {
  localStorage.setItem("messengerPropertyId", id);
  return {
    type: CHANGE_PROPERTYID,
    payload: id,
  };
};

export const changePropertyName = (id) => {
  localStorage.setItem("messengerPropertyName", id);
  return {
    type: CHANGE_PROPERTYNAME,
    payload: id,
  };
};

export const changeDomain = (id) => {
  localStorage.setItem("messengerDomain", id);
  return {
    type: CHANGE_DOMAIN,
    payload: id,
  };
};

export const changeAvatarClick = (id) => {
  sessionStorage.setItem("messengerAvatarClick", id);
  return {
    type: CHANGE_AVATARCLICK,
    payload: id,
  };
};

export const changeGroupId = (id) => {
  localStorage.setItem("messengerGroupId", id);
  return {
    type: CURRENT_GROUPID,
    payload: id,
  };
};

export const changeGroupName = (id) => {
  localStorage.setItem("messengerGroupName", id);
  return {
    type: CURRENT_GROUPNAME,
    payload: id,
  };
};

export const changeLevel = (id) => {
  localStorage.setItem("messengerLevel", id);
  return {
    type: CHANGE_LEVEL,
    payload: id,
  };
};

export const setIsGroupButton = (id) => {
  localStorage.setItem("messengerIsGroupButton", id);
  return {
    type: IS_GROUP_BUTTON,
    payload: id,
  };
};

export const change_Integration_Channel = (channel) => {
  return {
    type: CHANGE_INTEGRATION_CHANNEL,
    payload: channel,
  };
};

export const change_Chat_Started = (val) => {
  localStorage.setItem("messengerChatStarted", val);
  return {
    type: CHAT_STARTED,
    payload: val,
  };
};

export const changeBackToList = (val) => {
  return {
    type: CHANGE_BACK_TO_LIST,
    payload: val,
  };
};

export const changeCurrency = (val) => {
  localStorage.setItem("messengerCurrency", val);
  return {
    type: CHANGE_CURRENCY,
    payload: val,
  };
};

export const changeMode = (val) => {
  return {
    type: CHANGE_MODE,
    payload: val,
  };
};

export const changeBackToQuestion = (val) => {
  return {
    type: CHANGE_BACK_TO_QUESTION,
    payload: val,
  };
};